import { useMemo } from "react";
import { connect } from "react-redux";
import { useDates } from "dates/DatesContext";
import { useFetch } from "hooks/api";
import { buildMetric } from "views/merchandise/metrics";
import DetailedMetricRow from "components/core/blocks/DetailedMetricRow";
import PricingIcon from "assets/images/icons/pricing.svg";
import ThemeLine from "../ThemeLine";
import { keepPreviousData } from "@tanstack/react-query";

const PricingCard = ({ marketPlace, category = null }) => {
  const { start, end, preStart, preEnd, group } = useDates();
  const filters = {
    mp: marketPlace.marketPlace,
    date_group: group,
    start_date: start.format("YYYY-MM-DD"),
    end_date: end.format("YYYY-MM-DD"),
    pre_start_date: preStart.format("YYYY-MM-DD"),
    pre_end_date: preEnd.format("YYYY-MM-DD"),
    filters: "pricing_enrolled",
  };
  if (category) filters.category = category;

  const { data, isLoading } = useFetch(
    ["productReport", start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"), "pricing_enrolled", category, group],
    `/api/data_report/pricingplan_report`,
    filters,
    {
      select: (d) => d.data,
      placeholderData: keepPreviousData,
    },
  );

  const metrics = useMemo(() => {
    return [
      buildMetric(marketPlace.marketPlace, data, "sales", "sales_percent", {
        metric: {
          name: "Enrolled Sales",
          toolTip: "Total Sales from products enrolled in Dynamic Pricing",
        },
      }),
      buildMetric(marketPlace.marketPlace, data, "profit", "profit_percent"),
      buildMetric(marketPlace.marketPlace, data, "units", "units_percent"),
      buildMetric(marketPlace.marketPlace, data, "margin", "margin_delta"),
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return (
    <DetailedMetricRow
      small
      title={"Dynamic Pricing"}
      to={`/user/_pricing/dashboard`}
      byline={
        <>
          <ThemeLine>Pricing</ThemeLine>
          Enroll and manage product pricing
          {isLoading && <i className="fa fa-spinner fa-spin"></i>}
        </>
      }
      data={data?.date ?? []}
      metrics={metrics}
      group={group}
      icon={PricingIcon}
    />
  );
};

const mapStateToProps = (state) => ({
  marketPlace: state.marketPlace,
  user: state.user,
});

export default connect(mapStateToProps)(PricingCard);
